import { configureStore } from "@reduxjs/toolkit";
// import home from "../features/home/homeSlice";

export default configureStore({
  reducer: {
    // home,
  },
});
